import { action } from 'mobx';
import { ModalStore } from 'ui/base/modal';
import { BooleanStore, StringStore } from 'ui/base/input';
import { createAddressFilter } from 'ui/history/site_entry/site_entry_logic';
import { AddressSiteFilter } from 'services/pangolin/types';

function validate(address: string): boolean {
  const re_ipv4 = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  const re_ipv6 = /^((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?$/;
  const stripped = address.trim();
  return re_ipv4.test(stripped) || re_ipv6.test(stripped);
}

export class AddressInputStore {
  address: StringStore;
  modal: ModalStore;
  isValid: BooleanStore;

  constructor() {
    this.address = new StringStore('');
    this.modal = new ModalStore(false);
    this.isValid = new BooleanStore(true);
  }

  @action.bound
  commit(): AddressSiteFilter | undefined {
    const address = this.address.value;
    if (validate(address)) {
      this.isValid.setValue(true);
      return createAddressFilter(address);
    }
    this.isValid.setValue(false);
    return undefined;
  }

  @action.bound
  showModal() {
    this.address.setValue('');
    this.isValid.setValue(true);
    this.modal.showModal();
  }

  @action.bound
  hideModal() {
    this.modal.hideModal();
  }

  @action.bound
  toggleModal() {
    this.modal.visible = !this.modal.visible;
  }
}
